// // import React, { useEffect, useState, useCallback, forwardRef } from "react";
// // import { ExecutePostWithParams } from "../../../../../services/api/ExecuteApiRequests";
// // //prettier-ignore
// // import { Grid, Button, Typography, TextField, Paper } from "@mui/material";
// // import { IPDCToastMessageResult, IPDCAttachFile1 } from "../../../../../components/Controls";
// // import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
// // import * as MapDataLoader from "../MapRelated/MapData/MapDataLoader";
// // import * as turf from "@turf/turf";

// // //prettier-ignore
// // const MergeForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
// //   const [upin1, setUpin1] = useState("");
// //   const [upin2, setUpin2] = useState("");
// //   const [description, setDescription] = useState("");
// //   const [attachment, setAttachment] = useState(null);
// //   const [responseMessage, setResponseMessage] = useState("");
// //   const [alertSeverity, setAlertSeverity] = useState("info");
// //   const [lastFocusedField, setLastFocusedField] = useState(null);
// //   const [isSubmitting, setIsSubmitting] = useState(false); // Add loading state

// //   // Track which field was last focused
// //   const handleFieldFocus = (fieldName) => {
// //     setLastFocusedField(fieldName);
// //   };

// //   useEffect(() => {
// //     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
// //       const features = selectedFeatureOnMap.slice(0, 2);
// //       const upins = features.map(feature => feature.get("upin") || "");

// //       if (features.length === 1) {
// //         const selectedUpin = upins[0];
// //         if (lastFocusedField === 'upin1') {
// //           setUpin1(selectedUpin);
// //         } else if (lastFocusedField === 'upin2') {
// //           setUpin2(selectedUpin);
// //         } else {
// //           if (!upin1) {
// //             setUpin1(selectedUpin);
// //           } else if (!upin2) {
// //             setUpin2(selectedUpin);
// //           } else if (upin1 === upin2) {
// //             setUpin2(selectedUpin);
// //           } else {
// //             setUpin2(selectedUpin);
// //           }
// //         }
// //       } else {
// //         setUpin1(upins[0] || upin1);
// //         setUpin2(upins[1] || upin2);
// //       }
// //     }
// //   }, [selectedFeatureOnMap]);

// //   // Clear message after a delay
// //   const clearMessage = useCallback(() => {
// //     const timer = setTimeout(() => {
// //       setResponseMessage("");
// //       setAlertSeverity("info");
// //     }, 5000); // Clear after 5 seconds
    
// //     return () => clearTimeout(timer);
// //   }, []);

// //   const showToastMessage = useCallback((message, severity) => {
// //     // Clear previous message first
// //     setResponseMessage("");
    
// //     // Use setTimeout to ensure state update happens in next render cycle
// //     setTimeout(() => {
// //       setResponseMessage(message);
// //       setAlertSeverity(severity);
// //       clearMessage();
// //     }, 10);
// //   }, [clearMessage]);

// //   const checkFeatureAdjacency = useCallback(async (upin1, upin2) => {
// //     const existingParcels = await MapDataLoader.loadParcels();
// //     const [feature1, feature2] = [upin1, upin2].map(upin =>
// //       existingParcels.features.find(f => f.properties.upin === upin),
// //     );

// //     if (!feature1 || !feature2) {
// //       showToastMessage("No spatial data found for the given UPINs", "error");
// //       return false;
// //     }

// //     const bufferDistance = 1;
// //     const bufferedFeatures = [feature1, feature2].map(f => turf.buffer(f, bufferDistance, { units: "meters" }));

// //     const adjacencyChecks = [
// //       turf.booleanOverlap(feature1, feature2),
// //       turf.booleanContains(feature1, feature2),
// //       turf.booleanContains(feature2, feature1),
// //       turf.booleanWithin(feature1, feature2),
// //       turf.booleanWithin(feature2, feature1),
// //       turf.booleanOverlap(bufferedFeatures[0], feature2),
// //       turf.booleanOverlap(bufferedFeatures[1], feature1),
// //     ];

// //     return adjacencyChecks.some(check => check);
// //   }, [showToastMessage]);

// //   const bothParcelsOccupied = async (upin1, upin2) => {
// //     const existingParcels = await MapDataLoader.loadParcels();
// //     const [feature1, feature2] = [upin1, upin2].map(upin =>
// //       existingParcels.features.find(f => f.properties.upin === upin),
// //     );
    
// //     if (feature1 && feature2 && 
// //         feature1.properties.occupancy_status === 'Occupied' && 
// //         feature2.properties.occupancy_status === 'Occupied') {
// //       return true;
// //     } else {
// //       return false;
// //     }
// //   }

// //   const handleSubmit = async e => {
// //     e.preventDefault();
    
// //     // Prevent multiple submissions
// //     if (isSubmitting) {
// //       showToastMessage("Please wait, previous request is processing...", "info");
// //       return;
// //     }
    
// //     setIsSubmitting(true);

// //     try {
// //       // Validate UPINs are not empty
// //       if (!upin1.trim() || !upin2.trim()) {
// //         showToastMessage("Please enter both UPINs", "warning");
// //         return;
// //       }
      
// //       if (upin1 === upin2) {
// //         showToastMessage("The same Parcel Selected, Please enter two different parcels", "warning");
// //         return;
// //       }
      
// //       const areOccupied = await bothParcelsOccupied(upin1, upin2);
// //       if (areOccupied) {
// //         showToastMessage(`Parcel: ${upin1} and parcel ${upin2} Occupied, Not able to merge`, "error");
// //         return;
// //       }
      
// //       const areAdjacent = await checkFeatureAdjacency(upin1, upin2);

// //       if (!areAdjacent) {
// //         showToastMessage("The parcels are not adjacent, Please select correct features!", "warning");
// //       } else {
// //         await submitForm();
// //       }
// //     } catch (error) {
// //       console.error("Error in handleSubmit:", error);
// //       showToastMessage("An error occurred during validation", "error");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const submitForm = async () => {
// //     try {
// //       const formData = new FormData();
// //       formData.append("upin1", upin1);
// //       formData.append("upin2", upin2);
// //       formData.append("description", description);
// //       if (attachment) {
// //         formData.append("file", attachment);
// //       }
      
// //       const responseData = await ExecutePostWithParams("mergeParcel", formData, true);

// //       if (responseData) {
// //         showToastMessage("Merging request submitted successfully!", "success");
// //         resetForm();
// //       } else {
// //         showToastMessage("Merging failed!", "error");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       showToastMessage(`Merge failed: ${err.message}`, "error");
// //     }
// //   };

// //   const resetForm = () => {
// //     setUpin1("");
// //     setUpin2("");
// //     setDescription("");
// //     setAttachment(null);
// //     setLastFocusedField(null);
// //   };

// //   return (
// //     <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark }} elevation={3}>
// //       <Typography variant="h5" gutterBottom align="center">
// //         Merge Parcels
// //       </Typography>
// //       <form onSubmit={handleSubmit} ref={ref}>
// //         <Grid container spacing={1}>
// //           <Grid item xs={12}>
// //             <TextField 
// //               key="upin1"
// //               fullWidth 
// //               label="UPIN 1" 
// //               variant="outlined" 
// //               value={upin1} 
// //               onChange={e => setUpin1(e.target.value)} 
// //               onFocus={() => handleFieldFocus('upin1')}
// //               required 
// //             />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <TextField 
// //               key="upin2"
// //               fullWidth 
// //               label="UPIN 2" 
// //               variant="outlined" 
// //               value={upin2} 
// //               onChange={e => setUpin2(e.target.value)} 
// //               onFocus={() => handleFieldFocus('upin2')}
// //               required 
// //             />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <TextField 
// //               key="description"
// //               fullWidth 
// //               label="Description" 
// //               variant="outlined" 
// //               multiline 
// //               rows={3} 
// //               value={description} 
// //               onChange={e => setDescription(e.target.value)} 
// //             />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <IPDCAttachFile1 
// //               onChange={e => setAttachment(e[0])} 
// //               label="Attach Order Document" 
// //               variant="outlined" 
// //               multiLine={true} 
// //             />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <Button 
// //               type="submit" 
// //               variant="contained" 
// //               color="primary" 
// //               fullWidth
// //               disabled={isSubmitting} // Disable button when submitting
// //             >
// //               {isSubmitting ? "Merging..." : "Merge"}
// //             </Button>
// //           </Grid>
// //         </Grid>
// //       </form>
      
// //       {/* Show all messages using IPDCToastMessageResult */}
// //       {responseMessage && (
// //         <IPDCToastMessageResult 
// //           message={responseMessage} 
// //           type={alertSeverity} 
// //           onClose={() => setResponseMessage("")} // Allow manual close
// //         />
// //       )}
// //     </Paper>
// //   );
// // });

// // export default MergeForm;

// import React, { useEffect, useState, useCallback, forwardRef } from "react";
// import { ExecutePostWithParams } from "../../../../../services/api/ExecuteApiRequests";
// //prettier-ignore
// import { Grid, Button, Typography, TextField, Paper } from "@mui/material";
// import { IPDCToastMessageResult, IPDCAttachFile1 } from "../../../../../components/Controls";
// import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
// import * as MapDataLoader from "../MapRelated/MapData/MapDataLoader";
// import * as turf from "@turf/turf";

// //prettier-ignore
// const MergeForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
//   const [upin1, setUpin1] = useState("");
//   const [upin2, setUpin2] = useState("");
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const [lastFocusedField, setLastFocusedField] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false); // Add loading state

//   // Track which field was last focused
//   const handleFieldFocus = (fieldName) => {
//     setLastFocusedField(fieldName);
//   };

//   useEffect(() => {
//     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
//       const features = selectedFeatureOnMap.slice(0, 2);
//       const upins = features.map(feature => feature.get("upin") || "");

//       if (features.length === 1) {
//         const selectedUpin = upins[0];
//         if (lastFocusedField === 'upin1') {
//           setUpin1(selectedUpin);
//         } else if (lastFocusedField === 'upin2') {
//           setUpin2(selectedUpin);
//         } else {
//           if (!upin1) {
//             setUpin1(selectedUpin);
//           } else if (!upin2) {
//             setUpin2(selectedUpin);
//           } else if (upin1 === upin2) {
//             setUpin2(selectedUpin);
//           } else {
//             setUpin2(selectedUpin);
//           }
//         }
//       } else {
//         setUpin1(upins[0] || upin1);
//         setUpin2(upins[1] || upin2);
//       }
//     }
//   }, [selectedFeatureOnMap]);

//   // Clear message after a delay
//   const clearMessage = useCallback(() => {
//     const timer = setTimeout(() => {
//       setResponseMessage("");
//       setAlertSeverity("info");
//     }, 5000); // Clear after 5 seconds
    
//     return () => clearTimeout(timer);
//   }, []);

//   const showToastMessage = useCallback((message, severity) => {
//     // Clear previous message first
//     setResponseMessage("");
    
//     // Use setTimeout to ensure state update happens in next render cycle
//     setTimeout(() => {
//       setResponseMessage(message);
//       setAlertSeverity(severity);
//       clearMessage();
//     }, 10);
//   }, [clearMessage]);

//   // NEW FUNCTION: Check if parcels already have pending requests
//   const checkExistingRequests = useCallback(async (upin1, upin2) => {
//     try {
//       // Call API to check for existing merge requests for these UPINs
//       const response = await ExecutePostWithParams("checkExistingMergeRequests", { 
//         upin1: upin1.trim(), 
//         upin2: upin2.trim() 
//       }, false);
      
//       if (response && response.hasExistingRequests) {
//         return {
//           hasExisting: true,
//           message: response.message || `One or both parcels (${upin1}, ${upin2}) already have pending merge requests.`
//         };
//       }
      
//       return { hasExisting: false, message: "" };
//     } catch (error) {
//       console.error("Error checking existing requests:", error);
//       // If the check fails, we'll proceed with the merge request
//       return { hasExisting: false, message: "" };
//     }
//   }, []);

//   const checkFeatureAdjacency = useCallback(async (upin1, upin2) => {
//     const existingParcels = await MapDataLoader.loadParcels();
//     const [feature1, feature2] = [upin1, upin2].map(upin =>
//       existingParcels.features.find(f => f.properties.upin === upin),
//     );

//     if (!feature1 || !feature2) {
//       showToastMessage("No spatial data found for the given UPINs", "error");
//       return false;
//     }

//     const bufferDistance = 1;
//     const bufferedFeatures = [feature1, feature2].map(f => turf.buffer(f, bufferDistance, { units: "meters" }));

//     const adjacencyChecks = [
//       turf.booleanOverlap(feature1, feature2),
//       turf.booleanContains(feature1, feature2),
//       turf.booleanContains(feature2, feature1),
//       turf.booleanWithin(feature1, feature2),
//       turf.booleanWithin(feature2, feature1),
//       turf.booleanOverlap(bufferedFeatures[0], feature2),
//       turf.booleanOverlap(bufferedFeatures[1], feature1),
//     ];

//     return adjacencyChecks.some(check => check);
//   }, [showToastMessage]);

//   const bothParcelsOccupied = async (upin1, upin2) => {
//     const existingParcels = await MapDataLoader.loadParcels();
//     const [feature1, feature2] = [upin1, upin2].map(upin =>
//       existingParcels.features.find(f => f.properties.upin === upin),
//     );
    
//     if (feature1 && feature2 && 
//         feature1.properties.occupancy_status === 'Occupied' && 
//         feature2.properties.occupancy_status === 'Occupied') {
//       return true;
//     } else {
//       return false;
//     }
//   }

//   const handleSubmit = async e => {
//     e.preventDefault();
    
//     // Prevent multiple submissions
//     if (isSubmitting) {
//       showToastMessage("Please wait, previous request is processing...", "info");
//       return;
//     }
    
//     setIsSubmitting(true);

//     try {
//       // Validate UPINs are not empty
//       if (!upin1.trim() || !upin2.trim()) {
//         showToastMessage("Please enter both UPINs", "warning");
//         return;
//       }
      
//       if (upin1 === upin2) {
//         showToastMessage("The same Parcel Selected, Please enter two different parcels", "warning");
//         return;
//       }
      
//       // NEW: Check for existing requests before proceeding
//       const existingRequestsCheck = await checkExistingRequests(upin1, upin2);
//       if (existingRequestsCheck.hasExisting) {
//         showToastMessage(existingRequestsCheck.message, "warning");
//         return;
//       }
      
//       const areOccupied = await bothParcelsOccupied(upin1, upin2);
//       if (areOccupied) {
//         showToastMessage(`Parcel: ${upin1} and parcel ${upin2} Occupied, Not able to merge`, "error");
//         return;
//       }
      
//       const areAdjacent = await checkFeatureAdjacency(upin1, upin2);

//       if (!areAdjacent) {
//         showToastMessage("The parcels are not adjacent, Please select correct features!", "warning");
//       } else {
//         await submitForm();
//       }
//     } catch (error) {
//       console.error("Error in handleSubmit:", error);
//       showToastMessage(error, "error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const submitForm = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("upin1", upin1);
//       formData.append("upin2", upin2);
//       formData.append("description", description);
//       if (attachment) {
//         formData.append("file", attachment);
//       }
      
//       const responseData = await ExecutePostWithParams("mergeParcel", formData, true);

//       if (responseData) {
//         showToastMessage("Merging request submitted successfully!", "success");
//         resetForm();
//       } else {
//         showToastMessage("Merging failed!", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       showToastMessage(`Merge failed: ${err.message}`, "error");
//     }
//   };

//   const resetForm = () => {
//     setUpin1("");
//     setUpin2("");
//     setDescription("");
//     setAttachment(null);
//     setLastFocusedField(null);
//   };

//   return (
//     <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark }} elevation={3}>
//       <Typography variant="h5" gutterBottom align="center">
//         Merge Parcels
//       </Typography>
//       <form onSubmit={handleSubmit} ref={ref}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <TextField 
//               key="upin1"
//               fullWidth 
//               label="UPIN 1" 
//               variant="outlined" 
//               value={upin1} 
//               onChange={e => setUpin1(e.target.value)} 
//               onFocus={() => handleFieldFocus('upin1')}
//               required 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField 
//               key="upin2"
//               fullWidth 
//               label="UPIN 2" 
//               variant="outlined" 
//               value={upin2} 
//               onChange={e => setUpin2(e.target.value)} 
//               onFocus={() => handleFieldFocus('upin2')}
//               required 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField 
//               key="description"
//               fullWidth 
//               label="Description" 
//               variant="outlined" 
//               multiline 
//               rows={3} 
//               value={description} 
//               onChange={e => setDescription(e.target.value)} 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <IPDCAttachFile1 
//               onChange={e => setAttachment(e[0])} 
//               label="Attach Order Document" 
//               variant="outlined" 
//               multiLine={true} 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button 
//               type="submit" 
//               variant="contained" 
//               color="primary" 
//               fullWidth
//               disabled={isSubmitting} // Disable button when submitting
//             >
//               {isSubmitting ? "Merging..." : "Merge"}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
      
//       {/* Show all messages using IPDCToastMessageResult */}
//       {responseMessage && (
//         <IPDCToastMessageResult 
//           message={responseMessage} 
//           type={alertSeverity} 
//           onClose={() => setResponseMessage("")} // Allow manual close
//         />
//       )}
//     </Paper>
//   );
// });

// export default MergeForm;

import React, { useEffect, useState, useCallback, forwardRef } from "react";
import { ExecutePostWithParams } from "../../../../../services/api/ExecuteApiRequests";
//prettier-ignore
import { Grid, Button, Typography, TextField, Paper } from "@mui/material";
import { IPDCToastMessageResult, IPDCAttachFile1 } from "../../../../../components/Controls";
import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
import * as MapDataLoader from "../MapRelated/MapData/MapDataLoader";
import * as turf from "@turf/turf";

//prettier-ignore
const MergeForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
  const [upin1, setUpin1] = useState("");
  const [upin2, setUpin2] = useState("");
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [lastFocusedField, setLastFocusedField] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Helper function to convert any geometry to a format Turf can work with
  const convertToWorkableGeometry = useCallback((feature) => {
    if (!feature || !feature.geometry) return null;

    // If it's already a Polygon, return as is
    if (feature.geometry.type === 'Polygon') {
      return feature;
    }
    
    // If it's a MultiPolygon, take the largest polygon part
    if (feature.geometry.type === 'MultiPolygon') {
      console.log("Converting MultiPolygon to Polygon");
      
      // Find the polygon with the most vertices (likely the main polygon)
      let largestPolygon = null;
      let maxVertices = 0;
      
      feature.geometry.coordinates.forEach((polygonCoords) => {
        // Count total vertices in this polygon
        let vertexCount = 0;
        polygonCoords.forEach(ring => {
          vertexCount += ring.length;
        });
        
        if (vertexCount > maxVertices) {
          maxVertices = vertexCount;
          largestPolygon = {
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: polygonCoords
            },
            properties: feature.properties
          };
        }
      });
      
      return largestPolygon;
    }
    
    // For other geometry types, return as is (might still cause issues)
    return feature;
  }, []);

  // Helper function to safely perform Turf operations
  const safeTurfOperation = useCallback((operation, feature1, feature2, ...args) => {
    try {
      // Convert features to workable geometries
      const workingFeature1 = convertToWorkableGeometry(feature1);
      const workingFeature2 = convertToWorkableGeometry(feature2);
      
      if (!workingFeature1 || !workingFeature2) {
        console.warn("Could not convert features to workable geometries");
        return false;
      }
      
      // Perform the operation
      return operation(workingFeature1, workingFeature2, ...args);
    } catch (error) {
      console.warn(`Turf operation failed:`, error);
      return false;
    }
  }, [convertToWorkableGeometry]);

  // Track which field was last focused
  const handleFieldFocus = (fieldName) => {
    setLastFocusedField(fieldName);
  };

  useEffect(() => {
    if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
      const features = selectedFeatureOnMap.slice(0, 2);
      const upins = features.map(feature => feature.get("upin") || "");

      if (features.length === 1) {
        const selectedUpin = upins[0];
        if (lastFocusedField === 'upin1') {
          setUpin1(selectedUpin);
        } else if (lastFocusedField === 'upin2') {
          setUpin2(selectedUpin);
        } else {
          if (!upin1) {
            setUpin1(selectedUpin);
          } else if (!upin2) {
            setUpin2(selectedUpin);
          } else if (upin1 === upin2) {
            setUpin2(selectedUpin);
          } else {
            setUpin2(selectedUpin);
          }
        }
      } else {
        setUpin1(upins[0] || upin1);
        setUpin2(upins[1] || upin2);
      }
    }
  }, [selectedFeatureOnMap, lastFocusedField, upin1, upin2]);

  // Clear message after a delay
  const clearMessage = useCallback(() => {
    const timer = setTimeout(() => {
      setResponseMessage("");
      setAlertSeverity("info");
    }, 5000);
    
    return () => clearTimeout(timer);
  }, []);

  const showToastMessage = useCallback((message, severity) => {
    setResponseMessage("");
    
    setTimeout(() => {
      setResponseMessage(message);
      setAlertSeverity(severity);
      clearMessage();
    }, 10);
  }, [clearMessage]);

  // Check if parcels already have pending requests
  const checkExistingRequests = useCallback(async (upin1, upin2) => {
    try {
      const response = await ExecutePostWithParams("checkExistingMergeRequests", { 
        upin1: upin1.trim(), 
        upin2: upin2.trim() 
      }, false);
      
      if (response && response.hasExistingRequests) {
        return {
          hasExisting: true,
          message: response.message || `One or both parcels (${upin1}, ${upin2}) already have pending merge requests.`
        };
      }
      
      return { hasExisting: false, message: "" };
    } catch (error) {
      console.error("Error checking existing requests:", error);
      return { hasExisting: false, message: "" };
    }
  }, []);

  // Fixed adjacency check function that handles MultiPolygon geometries
  const checkFeatureAdjacency = useCallback(async (upin1, upin2) => {
    try {
      const existingParcels = await MapDataLoader.loadParcels();
      const [feature1, feature2] = [upin1, upin2].map(upin =>
        existingParcels.features.find(f => f.properties.upin === upin),
      );

      if (!feature1 || !feature2) {
        showToastMessage("No spatial data found for the given UPINs", "error");
        return false;
      }

      // Convert features to workable geometries first
      const workingFeature1 = convertToWorkableGeometry(feature1);
      const workingFeature2 = convertToWorkableGeometry(feature2);

      if (!workingFeature1 || !workingFeature2) {
        showToastMessage("Could not process parcel geometries", "error");
        return false;
      }

      const bufferDistance = 1;
      
      // Safely create buffers
      let bufferedFeature1 = null;
      let bufferedFeature2 = null;
      
      try {
        bufferedFeature1 = turf.buffer(workingFeature1, bufferDistance, { units: "meters" });
      } catch (error) {
        console.warn("Could not buffer feature1:", error);
      }
      
      try {
        bufferedFeature2 = turf.buffer(workingFeature2, bufferDistance, { units: "meters" });
      } catch (error) {
        console.warn("Could not buffer feature2:", error);
      }

      // Perform various adjacency checks using safe operations
      const checks = [
        safeTurfOperation(turf.booleanOverlap, workingFeature1, workingFeature2),
        safeTurfOperation(turf.booleanContains, workingFeature1, workingFeature2),
        safeTurfOperation(turf.booleanContains, workingFeature2, workingFeature1),
        safeTurfOperation(turf.booleanWithin, workingFeature1, workingFeature2),
        safeTurfOperation(turf.booleanWithin, workingFeature2, workingFeature1),
      ];

      // Add buffered checks if buffers were created successfully
      if (bufferedFeature1) {
        checks.push(safeTurfOperation(turf.booleanOverlap, bufferedFeature1, workingFeature2));
      }
      
      if (bufferedFeature2) {
        checks.push(safeTurfOperation(turf.booleanOverlap, bufferedFeature2, workingFeature1));
      }

      // Also check intersection as an additional adjacency indicator
      try {
        const intersection = turf.intersect(workingFeature1, workingFeature2);
        if (intersection) {
          checks.push(true);
        }
      } catch (error) {
        console.warn("Intersection check failed:", error);
      }

      // If any check passes, the parcels are adjacent
      return checks.some(check => check === true);
      
    } catch (error) {
      console.error("Error in checkFeatureAdjacency:", error);
      showToastMessage("Error checking parcel adjacency", "error");
      return false;
    }
  }, [showToastMessage, convertToWorkableGeometry, safeTurfOperation]);

  const bothParcelsOccupied = async (upin1, upin2) => {
    try {
      const existingParcels = await MapDataLoader.loadParcels();
      const [feature1, feature2] = [upin1, upin2].map(upin =>
        existingParcels.features.find(f => f.properties.upin === upin),
      );
      
      if (feature1 && feature2 && 
          feature1.properties.occupancy_status === 'Occupied' && 
          feature2.properties.occupancy_status === 'Occupied') {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error checking occupancy:", error);
      return false;
    }
  }

  const handleSubmit = async e => {
    e.preventDefault();
    
    // Prevent multiple submissions
    if (isSubmitting) {
      showToastMessage("Please wait, previous request is processing...", "info");
      return;
    }
    
    setIsSubmitting(true);

    try {
      // Validate UPINs are not empty
      if (!upin1.trim() || !upin2.trim()) {
        showToastMessage("Please enter both UPINs", "warning");
        setIsSubmitting(false);
        return;
      }
      
      if (upin1 === upin2) {
        showToastMessage("The same Parcel Selected, Please enter two different parcels", "warning");
        setIsSubmitting(false);
        return;
      }
      
      // Check for existing requests before proceeding
      const existingRequestsCheck = await checkExistingRequests(upin1, upin2);
      if (existingRequestsCheck.hasExisting) {
        showToastMessage(existingRequestsCheck.message, "warning");
        setIsSubmitting(false);
        return;
      }
      
      const areOccupied = await bothParcelsOccupied(upin1, upin2);
      if (areOccupied) {
        showToastMessage(`Parcel: ${upin1} and parcel ${upin2} Occupied, Not able to merge`, "error");
        setIsSubmitting(false);
        return;
      }
      
      const areAdjacent = await checkFeatureAdjacency(upin1, upin2);

      if (!areAdjacent) {
        showToastMessage("The parcels are not adjacent, Please select correct features!", "warning");
        setIsSubmitting(false);
      } else {
        await submitForm();
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      showToastMessage(error.message || "An error occurred during validation", "error");
      setIsSubmitting(false);
    }
  };

  const submitForm = async () => {
    try {
      const formData = new FormData();
      formData.append("upin1", upin1);
      formData.append("upin2", upin2);
      formData.append("description", description);
      if (attachment) {
        formData.append("file", attachment);
      }
      
      const responseData = await ExecutePostWithParams("mergeParcel", formData, true);

      if (responseData) {
        showToastMessage("Merging request submitted successfully!", "success");
        resetForm();
      } else {
        showToastMessage("Merging failed!", "error");
      }
    } catch (err) {
      console.error(err);
      showToastMessage(`Merge failed: ${err.message}`, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setUpin1("");
    setUpin2("");
    setDescription("");
    setAttachment(null);
    setLastFocusedField(null);
  };

  return (
    <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark }} elevation={3}>
      <Typography variant="h5" gutterBottom align="center">
        Merge Parcels
      </Typography>
      <form onSubmit={handleSubmit} ref={ref}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField 
              key="upin1"
              fullWidth 
              label="UPIN 1" 
              variant="outlined" 
              value={upin1} 
              onChange={e => setUpin1(e.target.value)} 
              onFocus={() => handleFieldFocus('upin1')}
              required 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              key="upin2"
              fullWidth 
              label="UPIN 2" 
              variant="outlined" 
              value={upin2} 
              onChange={e => setUpin2(e.target.value)} 
              onFocus={() => handleFieldFocus('upin2')}
              required 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              key="description"
              fullWidth 
              label="Description" 
              variant="outlined" 
              multiline 
              rows={3} 
              value={description} 
              onChange={e => setDescription(e.target.value)} 
            />
          </Grid>
          <Grid item xs={12}>
            <IPDCAttachFile1 
              onChange={e => setAttachment(e[0])} 
              label="Attach Order Document" 
              variant="outlined" 
              multiLine={true} 
            />
          </Grid>
          <Grid item xs={12}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              fullWidth
              disabled={isSubmitting}
            >
              {isSubmitting ? "Merging..." : "Merge"}
            </Button>
          </Grid>
        </Grid>
      </form>
      
      {/* Show all messages using IPDCToastMessageResult */}
      {responseMessage && (
        <IPDCToastMessageResult 
          message={responseMessage} 
          type={alertSeverity} 
          onClose={() => setResponseMessage("")}
        />
      )}
    </Paper>
  );
});

export default MergeForm;